import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextareaAutosize, Typography } from "@mui/material";
import { useAppDispatch } from "../../../redux/hooks";
import { addSnackbar } from "../../../redux/snackbars/snackbars.slice";
import { t } from "../../../i18n/translates";
import { ProjectInterface } from "../types";

export const TextToSpeechInstructionsEditorDialog = ({
    project,
    open,
    onClose,
    applyTtsInstructions,
    currentTtsInstructions,
    catchError,
}: {
    project: ProjectInterface;
    open: boolean;
    onClose: () => void;
    currentTtsInstructions: string;
    applyTtsInstructions: (instructions: string) => Promise<void>;
    catchError: (e: Error) => void;
}) => {
    const dispatch = useAppDispatch();
    const [ttsInstructions, setTtsInstructions] = useState(currentTtsInstructions);

    const uploadTtsInstructions = () => {
        applyTtsInstructions(ttsInstructions)
            .then(() => {
                dispatch(
                    addSnackbar({
                        color: "success",
                        title: t("common.saved"),
                    })
                );
                onClose();
            })
            .catch((err) => {
                catchError(err);
            });
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Edit Voice Prompt</DialogTitle>
            <DialogContent dividers>
                <Typography gutterBottom>
                    <TextareaAutosize
                        minRows={8}
                        style={{ width: "100%", maxWidth: "100%" }}
                        value={ttsInstructions}
                        onChange={(e) => setTtsInstructions(e.target.value)}
                        placeholder="Enter voice instructions (e.g., 'speak naturally and warmly', 'use a friendly tone', 'speak slowly and clearly')..."
                    />
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    These instructions tell the bot how to speak - you can specify the tone, speed, or style you want.
                    Leave empty to use the default voice settings.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => uploadTtsInstructions()}
                    disabled={project.isProtected}
                >
                    Save Voice Prompt
                </Button>
            </DialogActions>
        </Dialog>
    );
};
